import { DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR } from '@/constants/ui';
import React from 'react';

const MYOPurposeDomain = ({
  color,
  size = 50,
  background = DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR,
}: {
  color: string;
  size?: number;
  background?: string;
}) => (
  <svg viewBox="0 0 100 100" width={size} height={size} fill={'none'}>
    <rect width="100" height="100" rx="18" fill={background} />

    <g clipPath="url(#clip0_41_4916)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M69.0963 57.3847C72.2807 62.1608 76.647 68.7105 80.0586 73.8273C81.6366 76.1946 81.7835 79.2384 80.4412 81.7464C79.0989 84.2551 76.4847 85.8208 73.6397 85.8208H37.3017C37.3017 85.8208 50.2314 66.4265 56.2591 57.3847C57.6896 55.2383 60.0983 53.9491 62.678 53.9491C65.257 53.9491 67.6657 55.2383 69.0963 57.3847ZM44.6778 46.6761C46.2287 47.2247 47.587 48.2633 48.525 49.6704L51.873 54.6921L31.1204 85.8208H26.0018C23.1568 85.8208 20.5426 84.2551 19.2003 81.7464C17.8574 79.2384 18.0049 76.1946 19.5829 73.8273L35.6879 49.6704C36.6259 48.2633 37.9842 47.2247 39.5351 46.6761V16.3922C39.5351 15.5276 39.969 14.7216 40.691 14.2452C41.4125 13.7694 42.3246 13.6885 43.1195 14.0286C43.1195 14.0286 50.3123 17.1112 55.6043 19.3792C57.4952 20.1901 58.7215 22.049 58.7215 24.1065C58.7215 26.1641 57.4952 28.0229 55.6043 28.8338L44.6778 33.5167V46.6761Z"
        fill={color}
      />
    </g>
  </svg>
);

export default MYOPurposeDomain;
